document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on the login page
  if (window.location.pathname.includes('/account/login')) {
    // Check if the recovery form was just submitted (URL has the recover_customer_password parameter)
    if (window.location.search.includes('form_type=recover_customer_password')) {
      // Scroll to the top of the page
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      
      // Make sure the recover form is visible
      const loginForm = document.getElementById('login');
      const recoverForm = document.getElementById('recover');
      
      if (loginForm && recoverForm) {
        // Toggle the forms using the same classes as in the theme
        loginForm.classList.add('js-hidden');
        recoverForm.classList.remove('js-hidden');
        
        // Update URL hash to match the state
        if (window.location.hash !== '#recover') {
          history.pushState('', document.title, `${window.location.pathname}#recover`);
        }
      }
    }
  }
});
